module.exports = __webpack_public_path__ + "static/Screen record-9fc465bc2808a46e1547d61820380963.png";